export enum InvestmentConfirmationStepType {
    OFFER = 1,
    ACCEPT_OFFER = 2,
    FEE_AGREEMENT = 3,
    ACCEPT_FEE_AGREEMENT = 4
}
